<template>
    <div :class="cssClasses">
        <div class="eventInformation networkInformation">
            <v-container class='pt-0'>
                <v-layout row wrap>
                    <v-flex xs-12 sm10 class='information'>
                        <h4 v-if="extract('event.open')">Register for</h4>
                        <h3 v-html="extract('event.content.body.title') || extract('event.name')"></h3>
                        <div class="event-description" v-html="extract('event.content.body.description')"></div>
                        <table class="event-sections" v-if="extract('event.content.body.sections')">
                            <tr v-for="(obj, num) in extract('event.content.body.sections')" v-bind:key="num">
                                <td class="rowLabel"><h4 class="section-title my-4">{{ extract('event.content.body.sections.'+num+'.title') }}:</h4></td>
                                <td v-html="extract('event.content.body.sections.'+num+'.html')"></td>
                            </tr>
                        </table>
                        <div class="event-closing" v-if="extract('event.content.body.closing')" v-html="extract('event.content.body.closing')"></div>
                        <div>
                            <span class="capacity-notice" v-if="!loading && availableSlots < 1">The network is currently at capacity, but sign up below to be added to the wait list and we'll email you if a spot opens up.</span>
                        </div>
                    </v-flex>
                    <v-flex sm4 offset-sm1 class='callout' v-if="false">
                        <!-- IF DEFAULT ASIDE -->
                        <div class='whiteBox pa-4 mb-4 hidden-xs-only' v-if="hasAside" >
                            <div v-if="hasAside">
                                <div v-if="defaultAside">
                                    <!-- <p><img src="@/assets/es/Summit_SideCallout.svg" style='max-height: 200px; max-width:100%' /></p> -->
                                    <p><v-img src='@/assets/es/Summit_01@2x.jpg' /></p>
                                    <p><v-img src='@/assets/es/Summit_02@2x.jpg' /></p>
                                </div>
                               <div v-else class="customAside">
                                <AmazeDynamicComponent v-bind:template="extract('event.content.aside.html')"></AmazeDynamicComponent>
                            </div>
                            </div>
                        </div>
                        <!-- END DEFAULT ASIDE -->
                        <div id="refund-dialog">
                            <v-dialog v-model="dialog" max-width="500px">
                            <v-btn slot="activator"
                                   color="primary"
                                   style="display: none;"
                                   id="refund-dialog-button"
                                   class="mb-4 mt-4 ml-0">
                                Learn more about RTI's refund and cancellation policy
                            </v-btn>
                            <v-card>
                                <v-card-title>
                                    <h3 class="headline">Refund and Cancellation Policy</h3>
                                </v-card-title>
                                <hr class="thick" >

                                <v-card-text>
                                    <v-layout wrap>
                                        <div class='pa-2 mb-2'>
                                            <p>The {{ event.name }} Cancellation and Refund Policy will be as follows to assure consistency and is applicable to this network.</p>
                                            <p>{{ event.name }} registration canceled online on or before {{ getFormattedDate(event.refund_expiry) }} is refundable if already paid, or not due if not already paid. In order for your cancellation to be received, email <a href="mailto:educationservices@rti.org ">educationservices@rti.org</a> no later than {{ getFormattedDate(event.refund_expiry) }}.</p>
                                        </div>
                                    </v-layout>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                            color="blue darken-1"
                                            flat
                                            @click="dialog=false">Cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <!-- BEGIN THE FORMATIONING -->
        <div class="registrationForm" v-if="!loading">
            <div class="text-xs-center" v-if="!extract('event.open')">
                <h4>Registration is closed for this network.</h4>
            </div>
            <v-form ref="regForm" v-model="valid" v-if="!this.extract('event.content.form.custom') && extract('event.open')">
                <v-container>
                    <v-layout row wrap>
                        <v-flex md6>
                            <h3>Application <small><span class='star'>*</span> Indicates required fields </small></h3>
                            <h4 class="section-title my-4">Contact Information</h4>

                            <v-text-field v-model="firstName" required :rules="rules.populated">
                                <template slot="label">First Name<span class='star'>*</span></template>
                            </v-text-field>

                            <v-text-field id="middleInitial" class="small" v-model="middleInitial" required mask="A" :rules="rules.populated">
                                <template slot="label">Middle Initial<span class='star'>*</span></template>
                            </v-text-field>

                            <v-text-field v-model="lastName" required :rules="rules.populated">
                                <template slot="label">Last Name<span class='star'>*</span></template>
                            </v-text-field>

                            <v-text-field id="phoneNumber" class="medium" v-model="phoneNumber" required mask="(###) ### - ####" :rules="rules.phone">
                                <template slot="label">Contact Phone Number<span class='star'>*</span></template>
                            </v-text-field>

                            <AmazeEmailAddressInput v-model="personalEmail">
                                <template slot="label">Personal Email Address</template>
                            </AmazeEmailAddressInput>

                            <AmazeEmailAddressInput v-model="schoolEmail">
                                <template slot="label">School Email Address</template>
                            </AmazeEmailAddressInput>

                            <h5>Home Address</h5>

                            <AmazeAddress :address="homeAddress"></AmazeAddress>

                            <v-select :items="trafficChannels" v-model="trafficChannel" required :rules="rules.populated">
                             <template slot="label">
                              How did you hear about Aspire Teacher Prep?<span class='star'>*</span>
                              </template>
                            </v-select>

                            <v-text-field v-model="otherTrafficChannel" v-if="trafficChannel === 'Other'" :rules="trafficChannel === 'Other' ? rules.populated : []">
                                <template slot="label">Please elaborate on how you heard about the program.<span class='star'>*</span></template>
                            </v-text-field>

                            <h5 class="mb-4">Eligibility Requirements (choose all that apply)<span class='star'>*</span></h5>
                            <v-checkbox v-model="eligbilityRequirement" multiple v-for="(requirement, index) in eligbilityRequirements" :key="index" :label="requirement" :value="requirement" :rules="eligbilityRequirementRules" :hide-details="index != eligbilityRequirements.length - 1"></v-checkbox>

                            <h5>Testing Requirement<span class='star'>*</span></h5><strong>Before beginning any Aspire program, you will need to take the state tests for your licensure area if you do not have 24 content hours on your undergraduate degree. Do you need information about a Praxis II test?<span class='star'>*</span></strong>
                            <v-select :items="testingRequirements" v-model="testingRequirement" required :rules="rules.populated">
                              <template slot="label">
                                Select one of the following options.<span class='star'>*</span>
                              </template>
                            </v-select>

                            <h4 class="section-title my-4">Demographic Information</h4>

                            <v-select :items="genders" v-model="gender" required :rules="rules.populated">
                              <template slot="label">
                                Gender<span class='star'>*</span>
                              </template>
                            </v-select>

                            <v-select :items="races" v-model="race" required :rules="rules.populated">
                              <template slot="label">
                                Race<span class='star'>*</span>
                              </template>
                            </v-select>

                            <h4 class="section-title my-4">Licensure Information</h4>

                            <p><strong>Do you currently hold a teaching license (e.g. lateral entry, emergency, permit to teach, residency)?<span class='star'>*</span></strong></p>

                            <v-radio-group v-model="hasLicense" required :mandatory="true" :rules="rules.populated">
                              <v-radio label="Yes" value="Yes"></v-radio>
                              <v-radio label="No" value="No"></v-radio>
                            </v-radio-group>

                            <v-select v-if="hasLicense === 'Yes'" :items="licenses" v-model="license">
                              <template slot="label">
                                What teaching license do you hold?<span class='star'>*</span>
                              </template>
                            </v-select>

                            <v-text-field v-if="license === 'Other'" v-model="licenseOther" :rules="license === 'Other' ? rules.populated : []">
                                <template slot="label">You selected Other, please tell use about your teaching license.<span class='star'>*</span></template>
                            </v-text-field>

                            <v-select v-if="hasLicense === 'Yes' && license === 'Residency License'" :items="residencyYears" v-model="residence" :rules="hasLicense === 'Yes' && license === 'Residency License' ? rules.populated : []">
                              <template slot="label">
                                If you indicated having a residency license, in what year are you in residence?<span class='star'>*</span>
                              </template>
                            </v-select>

                            <v-text-field v-if="hasLicense === 'Yes'" v-model="licenseExpires" required mask="####" :rules="hasLicense === 'Yes' ? rules.populated : []">
                                <template slot="label">In what year does the license you hold expire?<span class='star'>*</span></template>
                            </v-text-field>

                            <v-text-field v-model="subject" required :rules="rules.populated">
                                <template slot="label">In what subject area do you currently or will you teach?<span class='star'>*</span></template>
                            </v-text-field>

                            <v-select :items="subjectAreas" v-model="subjectArea" required :rules="rules.populated">
                              <template slot="label">
                                In what subject area are you seeking licensure?<span class='star'>*</span>
                              </template>
                            </v-select>

                            <h4 class="section-title my-4">School Information</h4>

                            <v-text-field v-model="districtName" required :rules="rules.populated">
                                <template slot="label">School District<span class='star'>*</span></template>
                            </v-text-field>

                            <v-text-field v-model="schoolName" required :rules="rules.populated">
                                <template slot="label">School where you teach<span class='star'>*</span></template>
                            </v-text-field>

                            <h5>Principal</h5>
                            <v-text-field v-model="principalName" required :rules="rules.populated">
                                <template slot="label">Principal First and Last Name<span class='star'>*</span></template>
                            </v-text-field>

                            <AmazeEmailAddressInput v-model="principalEmail">
                                <template slot="label">Principal’s Email Address</template>
                            </AmazeEmailAddressInput>

                            <h5>Supervising Administrator</h5>
                            <v-text-field v-model="administratorName" required :rules="rules.populated">
                                <template slot="label">Supervising Administrator’s First and Last Name<span class='star'>*</span></template>
                            </v-text-field>

                            <AmazeEmailAddressInput v-model="administratorEmail">
                                <template slot="label">Supervising Administrator’s Email Address</template>
                            </AmazeEmailAddressInput>

                            <h5>Coach/Mentor</h5>
                            <v-text-field v-model="coachName" required :rules="rules.populated">
                                <template slot="label">Coach/Mentor First and Last Name<span class='star'>*</span></template>
                            </v-text-field>

                            <AmazeEmailAddressInput v-model="coachEmail">
                                <template slot="label">Coach/Mentor Email Address</template>
                            </AmazeEmailAddressInput>

                            <h5>District Human Resources Licensure Specialist</h5>
                            <v-text-field v-model="hrName" required :rules="rules.populated">
                                <template slot="label">District Human Resources Licensure Specialist Contact Name<span class='star'>*</span></template>
                            </v-text-field>

                            <AmazeEmailAddressInput v-model="hrEmail">
                                <template slot="label">District Human Resources Licensure Specialist Email Address</template>
                            </AmazeEmailAddressInput>

                            <h4 class="section-title my-4">Teaching and Learning Essay Questions</h4>

                            <p>Provide responses to the following questions using appropriate grammar, correct spelling, and full complete sentences. This program involves an extensive amount of writing. Therefore, it is critical that you <strong>review your responses prior to submitting your application</strong>. We suggest that you prepare your responses to the essay questions in a Word document/Google Document so that software spelling and grammar checks can be completed on your work prior to submission</p>
                            <br>

                            <p><strong>What do you hope to accomplish as a teacher?</strong><span class='star'>*</span><br>
                            <small>(Please limit your response to 300 words or less)</small></p>
                            <v-textarea outline v-model="teacherGoal" required :rules="rules.populated"></v-textarea>

                            <p><strong>What strategies do you use, or would you use, to support students in building a community with one another and with you as the teacher?</strong><span class='star'>*</span><br>
                            <small>(Please limit your response to 300 words or less)</small></p>
                            <v-textarea outline v-model="teacherStrategy" required :rules="rules.populated"></v-textarea>

                            <p><strong>Every student in your class does not need the same level or types of support or resources. How do you imagine you will support students individually and collectively to ensure they grow and learn in your classroom?</strong><span class='star'>*</span><br>
                            <small>(Please limit your response to 300 words or less)</small></p>
                            <v-textarea outline v-model="teacherSupport" required :rules="rules.populated"></v-textarea>

                            <p><strong>How do you best learn? What strategies do you use to keep you focused and on task? What supports do you need from others to keep you focused and on task?</strong><span class='star'>*</span><br>
                            <small>(Please limit your response to 300 words or less)</small></p>
                            <v-textarea outline v-model="teacherLearning" required :rules="rules.populated"></v-textarea>

                            <p><strong>Describe a challenge that you have experienced and how you faced the challenge along with the outcome of the challenge.</strong><span class='star'>*</span><br>
                            <small>(Please limit your response to 300 words or less)</small></p>
                            <v-textarea outline v-model="teacherChallenge" required :rules="rules.populated"></v-textarea>

                            <p><strong>Describe an accomplishment that was important to you and that you are most proud of from the last five years.</strong><span class='star'>*</span><br>
                            <small>(Please limit your response to 300 words or less)</small></p>
                            <v-textarea outline v-model="teacherAccomplishment" required :rules="rules.populated"></v-textarea>

                        </v-flex>
                        <v-flex xs12 sm12 md12 lg10>
                          <h4 class="section-title mb-4"><!--Section 3 -->Additional Documentation</h4>

                          <p>The following Items will need to be emailed to <a href="mailto:fnash@rti.org">fnash@rti.org</a> to complete your application</p>

                          <ul>
                            <li>All official degree dated academic transcripts with registrar signature and date</li>
                            <li>Copies of Praxis II score report (if available). We require Praxis II scores in the area of licensure if you do not have an undergraduate degree or 24 content hours in the area of licensure.</li>
                            <li>A copy of your previous Residency License (e.g., Residency license, Form RL, EPP documentation), Temporary license, or teaching contract for proof of employment if not currently teaching</li>
                            <li>If you are in Year 2 or Year 3 of Residency, previous Plan of Study from any previous Residency programs and documentation showing progress towards the completion of the program</li>
                          </ul>

                          <p class="mr-5 pr-5">To complete your submission, click on Submit Application below. After submitting your application, you will receive a confirmation email that your application has been received and follow up from Aspire Teacher Prep staff. All required information and official, legible transcripts (scans are eligible for admissions review, pictures are not), must be emailed. Incomplete applications will be maintained for 90 days. Afterwards, you will need to restart the application process.</p>
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg12 class="mt-20" >
                            <div class="submit-wrapper" v-if="registrants > 0" >
                                <div class="submit-success" v-if="this.submittedSuccessfully">
                                  <p><strong>Thank you for submitting your application materials to Aspire Teacher Prep.</strong> We have received your submission and will be in touch soon. To complete your application packet please submit the following items by email to <a href="mailto:fnash@rti.org">fnash@rti.org</a>.</p>
                                    <ul>
                                      <li>All official degree dated academic transcripts with registrar signature and date</li>
                                      <li>Copies of Praxis II score report (if available). We require Praxis II scores in the area of licensure if you do not have an undergraduate degree or 24 content hours in the area of licensure.</li>
                                      <li>A copy of your previous Residency License (e.g., Residency license, Form RL, EPP documentation), Temporary license, or teaching contract for proof of employment if not currently teaching</li>
                                      <li>If you are in Year 2 or Year 3 of Residency, previous Plan of Study from any previous Residency programs and documentation showing progress towards the completion of the program</li>
                                    </ul>
                                </div>
                                <div class="submit-incomplete" v-else>
                                    <h5 v-if="terms || acknowledgement">Application Signature</h5>
                                    <div v-if="terms || acknowledgement">
                                        <div v-if="acknowledgement">
                                          <v-checkbox
                                            required
                                            :rules="rules.acknowledge"
                                            v-model="acknowledge"
                                            :disabled="acknowledge"
                                            :label="acknowledgement"
                                          ></v-checkbox>
                                        </div>
                                    </div>
                                    <v-btn v-if="!submitted" class='ml-0' color="primary" @click="submitRegistration()">Submit Application</v-btn>
                                    <v-progress-circular v-else indeterminate />
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </div>

        <!-- END THE FORMATIONING -->

    </div>
</template>
<style scoped lang="scss">

</style>
<script>
import moment from 'moment'
// eslint-disable-next-line
import AmazeAddress from "@/components/Widgets/AmazeAddress"
import registrationMixin from "@/mixins/registrationMixin.js";

export default {
  mixins: [registrationMixin],
  data() {
    return {
      dialog: false,
      loading: true,
      valid: false,
      submitted: false,
      acknowledge: false,
      availableSlots: 0,
      maxRegistrants: 0,
      totalAttendees: 0,

      lastName: '',
      firstName: '',
      middleInitial: '',
      phoneNumber: '',
      personalEmail: '',
      schoolEmail: '',
      homeAddress: {
        street: null,
        city: null,
        state: null,
        zip: null
      },
      trafficChannel: null,
      trafficChannels: [
        'Referred by a friend or colleague',
        'Online search',
        'Social media',
        'Email/info session/outreach',
        'Other'
      ],
      otherTrafficChannel: null,
      eligbilityRequirement: [],
      eligbilityRequirements: [
        'I have a bachelor\'s degree',
        'My undergraduate GPA is at least a 2.7',
        'I have at least 24 hours of coursework relevant to my area of licensure (we will review your official transcript)',
        'I am currently employed in a LEA (Local Education Agency/District/School)',
        'I have previously held a Residency License or Emergency License'
      ],
      testingRequirement: null,
      testingRequirements: [
        'Yes, please email me',
        'No, I have a degree or 24 credit hours in the licensure area I seek',
        'No, I have already taken and passed the Praxis',
        'No, I have already taken but did not pass the Praxis',
        'No, I know what test(s) I need to take and have it scheduled',
        'No, I know what test(s) I need to take'
      ],
      gender: null,
      genders: [
        'Female',
        'Male',
        'Gender Neutral',
        'Prefer not to Answer'
      ],
      race: null,
      races: [
        'African-American/ Black',
        'American Indian/ Alaskan Native',
        'Asian',
        'Hispanic/Latinx',
        'Native Hawaiian/ Pacific Islander',
        'White',
        'Two or More Races',
        'Do not wish to provide'
      ],
      hasLicense: '',
      license: '',
      licenseOther: '',
      residence: '',
      licenseExpires: '',
      subject: '',
      subjectArea: '',
      schoolName: '',
      districtName: '',
      principalName: '',
      principalEmail: '',
      administratorName: '',
      administratorEmail: '',
      coachName: '',
      coachEmail: '',
      hrName: '',
      hrEmail: '',
      teacherGoal: '',
      teacherStrategy: '',
      teacherSupport: '',
      teacherLearning: '',
      teacherChallenge: '',
      teacherAccomplishment: '',
      roles: ['Principal', 'Lead Teacher', 'Lead Counselor', 'College Liaison', 'Other'],
      licenses: ['None', 'Residency License', 'Emergency License', 'Permit to Teach', 'Other'],
      residencyYears: ['1', '2', '3'],
      subjectAreas: [
        'Biology, 9 -12',
        'Chemistry, 9-12',
        'CTE: Agricultural Education',
        'CTE: Business & Information Technology Education',
        'CTE: Family & Consumer Sciences',
        'CTE: Marketing Education',
        'CTE: Technology Education',
        'Earth Science, 9- 12',
        'Economics, 9- 12',
        'English, 9-12',
        'Geography, 9-12',
        'History, 9 – 12',
        'Mathematics, 9 -12',
        'Middle Grades – Mathematics',
        'Middle Grades – Language Arts',
        'Middle Grades – Science',
        'Middle Grades – Social Studies',
        'Physics',
        'Political Science',
        'Science, 9 -12',
        'Social Studies, 9-12',
        'Sociology, 9 – 12'
      ],
      yesorno: ['Yes', 'No'],
      registrants: 5,
      numRegistrants: 5,
      registrant: [{
        name: '',
        email: null,
        role: 'Aspire Teacher'
      }],
      submittedSuccessfully: false,
      rules: {
        name: [v => !!v || "Name is required."],
        email: [
          v => !!v || "Email is required.",
          v => /@/.test(v) || "Please enter a valid email."
        ],
        phone: [v => !!v || "Phone Number is required.",
          v => (v || '').length === 10 || "Please enter a valid phone number."],
        populated: [v => !!v || "This field is required"],
        role: [v => !!v || "Role is required."],
        school: [v => !!v || "School name is required."],
        district: [v => !!v || "District name is required."],
        acknowledge: [v => !!v || "Please check the acknowledgement"]
      },
      event: {}
    };
  },
  watch: {
    billingSame: function(newVal, oldVal) {
      if (newVal) {
        this.cachedBilling = this.billingAddress;
        // Billing is same as school.
        this.billingAddress = this.schoolAddress;
      } else {
        if (this.cachedBilling) {
          this.billingAddress = this.cachedBilling;
        } else {
          this.billingAddress = this.defaultSchool;
        }
      }
    }
  },
  computed: {
    eligbilityRequirementRules() {
      return [
        this.eligbilityRequirement.length > 0 || "You must choose one eligibility requirement"
      ];
    },
    hasAside() {
      // var aside = this.extract('event.content.aside.custom');
      // return aside !== null && typeof aside !== 'undefined';
      return false; // Assume no sidebar for Aspire.
    },
    name() {
      return this.firstName + ' ' + this.middleInitial + ' ' + this.lastName;
    },
    teachingLicense() {
      if (this.license === 'Other') {
        return 'Other - ' + this.licenseOther;
      }
      return this.license;
    },
    contactAddress() {
      return process.env.VUE_APP_CONTACT_ADDRESS;
    },
    defaultSchool() {
      return {
        street: null,
        city: null,
        state: null,
        zip: null
      };
    },
    content() {
      return event.content ? event.content : false;
    },
    showWaiver() {
      // By default, we should be showing the waiver. However, if the waiver meta entry is set
      // to false, that indicates we should not show the waiver.
      return this.extract('event.content.meta.waiver', true);
    },
    registrationIsSingle() {
      return false;
    },
    registrantSlots() {
      let slots = [];
      for (let i = 1; i <= this.maxRegistrants; i++) {
        if (i === 1) {
          slots.push({ text: i + " attendee", value: i });
        } else {
          slots.push({ text: i + " attendees", value: i });
        }
      }
      return slots;
    },
    loaded() {
      return !this.loading;
    },
    showSubmitPrompt() {
      return !this.submittedSuccessfully && this.registrants > 0;
    }
  },
  methods: {
    // handleChange (event) {
    //   this.$emit("customChange", event.target.value.toUpperCase())
    // },

    formatPhoneNumber(number) {
      if (!(typeof number === 'string' || number instanceof String)) {
        number = '' + number;
      }

      if (number.length === 10) {
        return number.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
      }

      return '';
    },
    downloadTerms: function() {
      this.$refs.termsDownload.click();
    },
    getFormattedDate: function (date) {
      return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
    },
    initializeSlots() {
      let backup = this.registrant;
      this.registrant = [];
      for (let person = 0; person < this.registrants; person++) {
        if (backup[person]) {
          this.registrant[person] = backup[person];
        } else {
          this.registrant[person] = {
            name: '',
            email: null,
            role: null
          };
        }
      }
    },
    validateAll() {
      let cvalid =
        this.personalEmail && this.personalEmail.length &&
        this.schoolEmail && this.schoolEmail.length;

      return cvalid && this.$refs.regForm.validate();
    },
    submitRegistration() {
      if (this.validateAll()) {
        this.submitted = true;

        this.registrant[0].terms = this.acknowledge;
        this.registrant[0].name = this.name;
        this.registrant[0].email = this.personalEmail;
        this.registrant[0].role = 'Aspire Teacher - Applicant';

        let data = {
          registration_team_member: this.registrant,
          single_registration: false,
          school: this.schoolName,
          district: this.districtName,
          state: this.homeAddress.state,
          name: this.name,
          email: this.personalEmail,
          registration_team_member: this.registrant,
          team_total: 1,
          registration_event_id: this.extract('event.id'),
          extra_attributes: {
            "Last Name": this.lastName,
            "First Name": this.firstName,
            "Middle Initial": this.middleInitial,
            "Phone Number": this.phoneNumber,
            "Personal Email Address": this.personalEmail,
            "School Email Address": this.schoolEmail,
            "Home Address": this.homeAddress,
            "How did you hear about Aspire Teacher Prep": this.trafficChannel,
            "How did you hear about Aspire Teacher Prep (Other)": this.otherTrafficChannel,
            "Eligibility Requirements": this.eligbilityRequirement,
            "Testing Requirement": this.testingRequirement,
            "Gender": this.gender,
            "Race": this.race,
            "Do you currently hold a teaching license": this.hasLicense,
            "What teaching license do you hold": this.license,
            "Teaching License (Other)": this.licenseOther,
            "Residency Licence Year": this.residence,
            "In what year does the license you hold expire": this.licenseExpires,
            "In what subject area do you currently or will you teach": this.subject,
            "In what subject area are you seeking licensure": this.subjectArea,
            "School District": this.districtName,
            "School where you teach": this.schoolName,
            "Principal First and Last Name": this.principalName,
            "Principal Email Address": this.principalEmail,
            "Supervising Administrator First and Last Name": this.administratorName,
            "Supervising Administrator Email Address": this.administratorEmail,
            "Coach/Mentor First and Last Name": this.coachName,
            "Coach/Mentor Email Address": this.coachEmail,
            "District Human Resources Licensure Specialist Contact Name": this.hrName,
            "District Human Resources Licensure Specialist Email Address": this.hrEmail,
            "What do you hope to accomplish as a teacher": this.teacherGoal,
            "What strategies do you use, or would you use, to support students": this.teacherStrategy,
            "How do you imagine you will support students individually and collectively": this.teacherSupport,
            "How do you best learn": this.teacherLearning,
            "Describe a challenge that you have experienced": this.teacherChallenge,
            "Describe an accomplishment that was important to you": this.teacherAccomplishment
          }
        };

        this.$http.post('registrations', data).then(
          response => {
            this.submittedSuccessfully = true;
          },
          response => {
            this.submitted = false;
            this.$store.commit("updateMessage", {
              message: "There was a problem saving your application. Please try again or contact support.",
              snackbar: true
            });
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message: "Required fields are missing. Please review the form.",
          snackbar: true
        });
      }
    }
  },
  mounted() {
    this.$http.get('event/' + (this.$route.params.slug || this.$route.path.split('/').pop())).then((response) => {
      this.event = response.data.data[0];

      this.totalAttendees = this.extract('event.total_attendees') || 0;
      this.maxAttendees = this.extract('event.max_attendees') || 0;

      this.availableSlots = Math.max(0, this.maxAttendees - this.totalAttendees);

      this.maxRegistrants = this.extract('event.max_per_team');
      // If we need to limit registration to only accept the max number of slots, we can use the following logic:
      // Math.min(this.extract('event.max_per_team'), (this.maxAttendees - this.totalAttendees));

      var fields = this.extract('event.content.form.fields');

      if (fields) {
        for (const key in fields) {
          var field = fields[key];
          // Set defaults.
          if (field.hasOwnProperty('default')) {
            this[key] = field.default;
          }
          // Set values.
          if (field.hasOwnProperty('values')) {
            this[key] = field.values;
          }
        }
      }

      if (this.maxRegistrants === 1) {
        // Single registration, set-up initial object to avoid null object errors.
        this.registrant.push({ "name": '', "email": null, role: null });
        this.registrants = 1;
      }

      this.loading = false;
    // eslint-disable-next-line handle-callback-err
    }, error => {
      this.$router.push('/404')
    });
  }
}
</script>
